<template>
  <!-- 
    @name 杭州新征信
   -->
  <div class="hang_credit">
    <div v-if="isSecurity">
      <!-- 有报告 -->
      <div v-if="zxReport">
        <el-button type="warning" plain @click="queryCredit">
          重新生成该报告
        </el-button>

        <iframe :src="zxReportUrl" width="100%" height="800" frameborder="0" />
      </div>
      <!-- 没有报告 -->
      <div v-else class="bg_else" style="text-align: center;">
        <div class="prompt">提示：请生成报告后再查看该报告！</div>
        <div class="report">征信报告没有生成</div>
        <div class="create">
          <el-button
            type="warning"
            style="width: 120px"
            plain
            @click="createESign"
            >生成个人授权书</el-button
          >
          <el-button
            type="warning"
            style="width: 108px"
            plain
            @click="queryCredit"
            >生成该报告</el-button
          >
        </div>
      </div>
    </div>

    <div v-else>
      <div class="warning_info">提示：请充值！</div>
    </div>
  </div>
</template>

<script>
import FengkongApi from "@/api/fengkong.js";
import isSecurity from "@/utils/isSecurity.js";
import useApi from "@/api/useApi.js";
import { getFile, base64Handle } from "@/utils/tools.js";

export default {
  props: ["detail", "credit_url"],
  data() {
    return {
      loading: false, //
      zxReport: false, // 是否有报告
      order_id: "", // 订单id
      isSecurity: true, // false 显示充值提醒
      zxReportUrl: "" // 报告地址
    };
  },
  mounted() {
    const self = this;
    isSecurity().then(result => {
      console.log(result);
      self.isSecurity = result;
    });
    if (this.credit_url !== "") {
      this.zxReport = true;
      this.zxReportUrl = this.credit_url;
    }
  },
  methods: {
    // 重新生成报告
    reCreate() {
      console.log("重新生成报告", this.detail);
    },
    async queryCredit() /*征信查询*/ {
      const detail = this.detail;

      await this.$confirm("首次查询需要1~3分钟时间", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info "
      });
      const { data } = await useApi().queryCredit({
        user_id: detail.user_id,
        order_id: detail.order_id
      });
      const self = this;
      if (data.credit_url) {
        this.zxReportUrl = data.credit_url;
        this.zxReport = true;
      } else
        setTimeout(() => {
          console.log(this);
          this.loadCredit(data.order_no);
        }, 10 * 1000);
    },
    async loadCredit(num) /*加载征信报告*/ {
      const { data } = await useApi().queryResult({ orderNo: String(num) });
      this.zxReportUrl = data;
      this.zxReport = true;
    },
    // 生成e签宝静默签
    async createESign() {
      const HAO_CHEN_DAR = "zhangqian";
      const param = { type: HAO_CHEN_DAR, order_id: this.detail.order_id };
      await FengkongApi.createAuthorization(param, true);
      await this.$parent.getParams();
      this.$message.success("已生成授权书");
    }
  },
  created() {}
};
</script>

<style lang="scss" scoped>
.bg_else .prompt {
  margin-top: 50px;
}

.bg_else .report {
  /* margin-left: 700px; */
  font-size: 30px;
}

.bg_else .create {
  /* margin-left: 760px; */
  font-size: 30px;
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/fengkong/operation/HangzhouCreditReport.vue